// 关键：导入你封装的独立 isMobile 函数（和 main.js 中挂载的是同一个）
import { isMobile } from '@/utils/device'
import Vue from 'vue'
import VueRouter from 'vue-router'
// import home from '../pc/views/home/home.vue'
// import aboutus from '../pc/views/aboutus/index.vue'
// import swiper_one from '../pc/views/aboutus/swiper/swiper_one.vue'
// import linecard from '../pc/views/linecard/index.vue'
// import putBrand from '../pc/views/linecard/putBrand.vue'
// import qualitycontrol from '../pc/views/qualitycontrol/index.vue'
// import applications from '../pc/views/applications/index.vue'
// import contactus from '../pc/views/contactus/index.vue'
// import introduction from '../pc/views/introduction/index.vue'
// import aboutabracon from '../pc/views/aboutabracon/index.vue'
// import joinus from '../pc/views/joinus/index.vue'
// import vdetails from '../pc/views/home/details/vdetails.vue'
// import cdetails from '../pc/views/home/details/cdetails.vue'
// import qdetails from '../pc/views/home/details/qdetails.vue'
// import wdetails from '../pc/views/home/details/wdetails.vue'

// import hdetails from '../pc/views/applications/details/hdetails.vue'
// import icdetails from '../pc/views/applications/details/icdetails.vue'
// import medetails from '../pc/views/applications/details/medetails.vue'
// import aedetails from '../pc/views/applications/details/aedetails.vue'
// import idetails from '../pc/views/applications/details/idetails.vue'
// import cndetails from '../pc/views/applications/details/cndetails.vue'

// import terms from '../pc/views/terms/index.vue'
// import GTCS from '../pc/views/GTCS/index.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => isMobile()
      ? import('../mobile/views/home/home.vue')  // 从 router 目录出发
      : import('../pc/views/home/home.vue')
    },
   {
    path: '/prodSearch',
    name: 'prodSearch',
    component: () => {
      if (isMobile()) {
        // return import('../mobile/views/aboutus/swiper/swiper_one.vue');
      } else {
        return import('../pc/views/prodSearch/index.vue');
      }
    },
    // meta: {
    //   title: ''
    // }
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/aboutus/index.vue');
      } else {
        return import('../pc/views/aboutus/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 关于我们'
    }
  },
  {
    path: '/swiper_one',
    name: 'swiper_one',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/aboutus/swiper/swiper_one.vue');
      } else {
        return import('../pc/views/aboutus/swiper/swiper_one.vue');
      }
    },
    // meta: {
    //   title: '宏能电子 | 2020年会'
    // }
  },
  {
    path: '/linecard',
    name: 'linecard',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/linecard/index.vue');
      } else {
        return import('../pc/views/linecard/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 品牌介绍'
    }
  },
  {
    path: '/putBrand',
    name: 'putBrand',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/linecard/putBrand.vue');
      } else {
        return import('../pc/views/linecard/putBrand.vue');
      }
    },
    meta: {
      title: '宏能电子 | 品牌分销'
    }
  },
  {
    path: '/qualitycontrol',
    name: 'qualitycontrol',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/qualitycontrol/index.vue');
      } else {
        return import('../pc/views/qualitycontrol/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 质量管理'
    }
  },
  {
    path: '/applications',
    name: 'applications',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/index.vue');
      } else {
        return import('../pc/views/applications/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 研发中心'
    }
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/terms/index.vue');
      } else {
        return import('../pc/views/terms/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 销售条款和条件'
    }
  },
  {
    path: '/GTCS',
    name: 'GTCS',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/GTCS/index.vue');
      } else {
        return import('../pc/views/GTCS/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 全球贸易合规声明'
    }
  },
  
  {
    path: '/contactus',
    name: 'contactus',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/contactus/index.vue');
      } else {
        return import('../pc/views/contactus/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 联系我们'
    }
  },
  {
    path: '/introduction',
    name: 'introduction',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/introduction/index.vue');
      } else {
        return import('../pc/views/introduction/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 公司简介'
    }
  },
  {
    path: '/aboutabracon',
    name: 'aboutabracon',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/aboutabracon/index.vue');
      } else {
        return import('../pc/views/aboutabracon/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 关于ABRACON'
    }
  },
  {
    path: '/joinus',
    name: 'joinus',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/joinus/index.vue');
      } else {
        return import('../pc/views/joinus/index.vue');
      }
    },
    meta: {
      title: '宏能电子 | 加入我们'
    }
  },
  {
    path: '/vdetails',
    name: 'vdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/home/details/vdetails.vue');
      } else {
        return import('../pc/views/home/details/vdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 渠道控制'
    }
  },
  {
    path: '/cdetails',
    name: 'cdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/home/details/cdetails.vue');
      } else {
        return import('../pc/views/home/details/cdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 检验设备'
    }
  },
  {
    path: '/qdetails',
    name: 'qdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/home/details/qdetails.vue');
      } else {
        return import('../pc/views/home/details/qdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | OQC流程'
    }
  },
  {
    path: '/wdetails',
    name: 'wdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/home/details/wdetails.vue');
      } else {
        return import('../pc/views/home/details/wdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 仓库管理'
    }
  },
  {
    path: '/hdetails',
    name: 'hdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/hdetails.vue');
      } else {
        return import('../pc/views/applications/details/hdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 宏能知识产权统计表'
    }
  },
  {
    path: '/icdetails',
    name: 'icdetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/icdetails.vue');
      } else {
        return import('../pc/views/applications/details/icdetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 工业控制'
    }
  },
  {
    path: '/medetails',
    name: 'medetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/medetails.vue');
      } else {
        return import('../pc/views/applications/details/medetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 医疗电子'
    }
  },
  {
    path: '/aedetails',
    name: 'aedetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/aedetails.vue');
      } else {
        return import('../pc/views/applications/details/aedetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 汽车电子'
    }
  },
  {
    path: '/idetails',
    name: 'idetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/idetails.vue');
      } else {
        return import('../pc/views/applications/details/idetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | IOT'
    }
  },
  {
    path: '/cndetails',
    name: 'cndetails',
    component: () => {
      if (isMobile()) {
        return import('../mobile/views/applications/details/cndetails.vue');
      } else {
        return import('../pc/views/applications/details/cndetails.vue');
      }
    },
    meta: {
      title: '宏能电子 | 通讯'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
//跳转页面页面没有滑倒顶部
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    let zhTitle = ['深圳市宏能微电子有限公司','宏能电子 | 关于我们','宏能电子 | 品牌介绍','宏能电子 | 质量管理','宏能电子 | 研发中心','宏能电子 | 联系我们',
      '宏能电子 | 公司简介',
      '宏能电子 | 关于ABRACON',
      '宏能电子 | 加入我们',
      '宏能电子 | 2022年度前50名',
      '宏能电子 | 品牌分销',
      '宏能电子 | 渠道控制',
      '宏能电子 | 检验设备',
      '宏能电子 | OQC流程',
      '宏能电子 | 仓库管理',
      '宏能电子 | 产品应用',
      '宏能电子 | 知识产权',
      '宏能电子 | 宏能知识产权统计表',
      '宏能电子 | 工业控制',
      '宏能电子 | 医疗电子',
      '宏能电子 | 汽车电子',
      '宏能电子 | IOT',
      '宏能电子 | 通讯',
      '宏能电子 | 销售条款和条件',
      '宏能电子 | 2020年会',
      '宏能电子 | 2019年会',
      '宏能电子 | 拓展活动',
      '宏能电子 | 2019重庆',
      '宏能电子 | 2018泰国',
      '宏能电子 | 2017云南'
     ]

    let enTitle = ['Honeng Electronics', 'Honeng Electronics | About Us','Honeng Electronics | line Card','Honeng Electronics | Quality Control','Honeng Electronics | R&D Center','Honeng Electronics | Contact Us',
      'Honeng Electronics | Introduction',
      'Honeng Electronics | About Abracon',
      'Honeng Electronics | Join Us',
      'Honeng Electronics | Top 50 Lines',
      'Honeng Electronics | Promotion lines',
      'Honeng Electronics | Channel Control',
      'Honeng Electronics | Testing equipment',
      'Honeng Electronics | OQC Process',
      'Honeng Electronics | Warehouse Management',
      'Honeng Electronics | Product Application',
      'Honeng Electronics | Intellectual Property',
      'Honeng Electronics | Honeng’s intellectual property Statistical table',
      'Honeng Electronics | Industrial Control',
      'Honeng Electronics | Medical Electronics',
      'Honeng Electronics | Automotive Electronics',
      'Honeng Electronics | IOT',
      'Honeng Electronics | Communication',
      'Honeng Electronics | Sales terms and conditions',
      'Honeng Electronics | 2020 Annual Meeting',
      'Honeng Electronics | 2019 Annual Meeting',
      'Honeng Electronics | Outreach activities',
      'Honeng Electronics | 2019 Chongqing',
      'Honeng Electronics | 2018 Thailand',
      'Honeng Electronics | 2017 Yunnan'
     ]
    var language = localStorage.getItem("locale") || 'zh'
    if (language == 'zh') {
      zhTitle.map(item => {
        if (item == to.meta.title) {
          document.title = item
        }
      })
    } else {
      for (var i = 0; i < zhTitle.length; i++) {
        if (zhTitle[i] == to.meta.title) {
          document.title = enTitle[i]
        }
      }
    }

  }
  window.scrollTo(0, 0); // 滚动到顶部
  next();
});

//当前页面跳转当前页面报错解决
// 获取原始的 push 和 replace 方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
// 重写 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
export default router